import { connect } from "react-redux";
import LoginV from "./Login";
import SSOReturnV from "./SSOReturn";
import { actions } from "./logic/actions";
function mapStateToProps (state)  {
    return {
        ...state.login,
    };
}
function mapDispatchToProps (dispatch)  {
    return {
        login: (username, password) => dispatch(actions.AUTH_USER.send({username, password})),
        ssoReturnVerify: (username) => dispatch(actions.AUTH_USER_VERIFY_SSO.send({username})),
    };
}
export const Login = connect(mapStateToProps,mapDispatchToProps )(LoginV);

export const SSOReturn = connect(mapStateToProps,mapDispatchToProps )(SSOReturnV);